<template>
  <section class="orderFilters">
    <div class="orderFilters__containerRow">
      <span class="orderFilters__title">Ordenar por</span>
      <iconic class="orderFilters__icon" name="closeBold" @click.native="close('showMenuOrder')" />
    </div>
    <div class="orderFilters__container">
      <div class="orderFilters__item" @click="setDataFilter('atoz')">
        <span class="orderFilters__text">Usuarios: A - Z</span>
      </div>
      <div class="orderFilters__item" @click="setDataFilter('ztoa')">
        <span class="orderFilters__text">Usuarios: Z - A</span>
      </div>
      <div class="orderFilters__item" @click="setDataFilter('newtoold')">
        <span class="orderFilters__text">Nuevos primero</span>
      </div>
      <div class="orderFilters__item" @click="setDataFilter('oldtonew')">
        <span class="orderFilters__text">Antiguos primero</span>
      </div>
      <div class="orderFilters__item" @click="setDataFilter('anewtoaold')">
        <span class="orderFilters__text">Actividad reciente</span>
      </div>
      <div class="orderFilters__item" @click="setDataFilter('aoldtoanew')">
        <span class="orderFilters__text">Actividad antigua</span>
      </div>
    </div>
  </section>
</template>

<script>
import setfilter from "@/mixins/setfilter";
export default {
  mixins: [setfilter],
  props: ["close"],
  methods: {
    setDataFilter(filterOrder) {
      this.setFilter({ srcElement: { name: "order", value: filterOrder } });
      this.close("showMenuOrder");
    },
  },
};
</script>

<style lang="scss">
.orderFilters {
  @include Flex(column, flex-start);
  gap: 5px;
  width: 230px;
  background: #ffffff;
  border: 1px solid $alto;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  &__containerRow {
    @include Flex(row, space-between);
    width: 100%;
    gap: $mpadding;
    padding: $mpadding $mpadding 0 $mpadding;
    &--pointer {
      cursor: pointer;
    }
    &--end {
      justify-content: center;
    }
  }
  &__title {
    font-weight: 600;
    user-select: none;
  }
  &__icon {
    padding: 5px;
    font-size: 14px;
    cursor: pointer;
  }
  &__container {
    @include Flex(column, flex-start);
    width: 100%;
  }
  &__item {
    @include Flex(row, flex-start);
    width: 100%;
    padding: 10px 16px;
    &:hover {
      background: #f4f4f4;
      cursor: pointer;
    }
  }
  &__text {
    font-weight: 600;
    font-size: 15px;
    color: $chicago;
  }
}
</style>
